<template>
  <div class="step-indicator">
    <div class="step-indicator tabs-section d-flex">
      <div
        v-for="(item, index) in steps"
        :key="index"
        @click="changeStep(item.number)"
        :class="{
          active: step === item.number,
          unblocked: !isTabsBlocked,
          disabled: !stepIsAvailable(item.number)
        }"
        class="tab"
      >
        <span class="tab__name">{{ item.name }}</span>
        <span class="tab__description">{{ item.description }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'StepIndicator',
    emits: [
      'change-step',
    ],
    data () {
      return {
        steps: [
          {
            number: 1,
            name: 'Шаг 1',
            description: 'адрес',
          },
          {
            number: 2,
            name: 'Шаг 2',
            description: 'заказ',
          },
          {
            number: 3,
            name: 'Шаг 3',
            description: 'оплата',
          },
        ],
      }
    },
    props: {
      step: {
        type: Number,
        default: 0,
      },
      isTabsBlocked: {
        type: Boolean,
        default: false,
      },
      availableSteps: {
        type: Array,
        default: () => ([]),
      },
      availableAllSteps: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      stepIsAvailable (number) {
        return this.availableAllSteps || this.availableSteps.includes(number)
      },
      changeStep (number) {
        if (this.stepIsAvailable(number)) {
          this.$emit('change-step', number)
        }
      },
    },
  }
</script>

<style scoped lang="less">
.step-indicator {
  .tabs-section {
    margin-bottom: 20px;
    border-bottom: 1px solid #d4d4d4;

    .tab {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: 1.71em;
      line-height: 1.3;
      font-weight: bold;
      background-color: transparent;
      flex: 1;
      height: 2.65em;
      border-radius: 5px 5px 0 0;
      outline: none;
      cursor: pointer;

      &.unblocked {
        cursor: pointer;
      }

      &.active {
        background-color: @color-primary;
        color: #ffffff;
      }

      &.disabled {
        color: @color-btn-dark-grey;
        cursor: not-allowed;
      }

      &__description {
        font-size: 11px;
        font-weight: normal;
        text-transform: uppercase;
      }
    }

    // компактный десктоп: вкладки шагов ниже и с меньшим шрифтом - высота
    // панели заказа нужна списку блюд
    .media-compact-pc({
      margin-bottom: 12px;

      .tab {
        font-size: 1.42em;
        line-height: 1.2;
        height: 2.5em;

        &__description {
          font-size: 10px;
        }
      }
    });
  }

}

</style>
